// "Only the first N products" of a category import link. Empty = every product of the
// link (the default); a number = its first N products in the page's own order, e.g. the
// top 100 of a bestseller-sorted category.

// Suggested in the Add dialog when "only the first" is picked: Hepsiburada's first listing
// page holds 36 products, Trendyol's "Enler" lists are top 100s.
export const defaultImportLimit = (url) => (/hepsiburada\.com/i.test(url || '') ? 36 : 100);

// The products_create request for a category link; import_limit only when it is set.
export const buildCategoryImportRequest = (url, campaignId, limitOn, limit) => {
    const request = {url: url.trim(), type: 'products_create', campaign_id: campaignId};
    if (limitOn && limit > 0) request.import_limit = limit;
    return request;
};
